<template>
    <section class='main'>
        <div class='crumbs'>
            <el-breadcrumb separator='/'>
                <el-breadcrumb-item><i class='el-icon-lx-profile'></i> 系统相关</el-breadcrumb-item>
                <el-breadcrumb-item>权限接口管理</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        
        <div class='container' style='min-width: 900px'>
            <div class='plugins-tips'>
                <el-row>
                    <el-col :span='17'>
                        <el-form v-show='showSearch' ref='queryForm' :inline='true' :model='queryParams' size='small'>
                            <el-form-item label='接口名' prop='dictName' style='margin-bottom: 0'>
                                <el-input
                                    v-model='queryParams.name'
                                    clearable
                                    placeholder='请输入接口名'
                                    style='width: 240px'
                                    @keyup.enter.native='handleQuery'
                                />
                            </el-form-item>
                            <el-form-item label='接口id' prop='dictType' style='margin-bottom: 0'>
                                <el-input
                                    v-model='queryParams.id'
                                    clearable
                                    placeholder='请输入接口id'
                                    style='width: 240px'
                                    @keyup.enter.native='handleQuery'
                                />
                            </el-form-item>
                            <el-form-item label='接口地址' prop='dictType' style='margin-bottom: 0'>
                                <el-input
                                    v-model='queryParams.url'
                                    clearable
                                    placeholder='请输入接口地址'
                                    style='width: 240px'
                                    @keyup.enter.native='handleQuery'
                                />
                            </el-form-item>
                            <el-form-item style='margin-bottom: 0'>
                                <el-button icon='el-icon-search' size='mini' type='primary' @click='handleQuery'>搜索
                                </el-button>
                                <el-button icon='el-icon-refresh' size='mini' @click='resetQuery'>重置</el-button>
                            </el-form-item>
                        </el-form>
                    </el-col>
                    <el-col :span='7'>
                        <el-row class='mb8'>
                            <el-col :span='8'>
                                <el-button
                                    icon='el-icon-plus'
                                    plain
                                    size='mini'
                                    type='primary'
                                    @click='handleAdd'
                                >新增
                                </el-button>
                            </el-col>
                            <el-col :span='8'>
                                <el-button
                                    icon='el-icon-delete-solid'
                                    plain
                                    size='mini'
                                    type='warning'
                                    :disabled='!batchDeleteStatus'
                                    @click='handleBatchDelete'
                                >批量删除
                                </el-button>
                            </el-col>
                            <el-col :span='8'>
                                <el-button
                                    icon='el-icon-download'
                                    plain
                                    size='mini'
                                    type='warning'
                                    @click='handleImport'
                                >导入
                                </el-button>
                            </el-col>
                        </el-row>
                    </el-col>
                </el-row>
            </div>
            
            <el-table v-loading='loading' :cell-style="{ textAlign: 'center' }" :data='permissionList'
                      @selection-change='handleSelectionChange'>
                <el-table-column align='center' type='selection' width='55' />
                <el-table-column align='center' label='接口id' prop='id' />
                <el-table-column :show-overflow-tooltip='true' align='center' label='接口名' prop='name' />
                <el-table-column :show-overflow-tooltip='true' align='center' label='接口地址' prop='url' />
                <el-table-column align='center' class-name='small-padding fixed-width' label='操作'>
                    <template slot-scope='scope'>
                        <el-button
                            icon='el-icon-edit'
                            size='mini'
                            type='text'
                            @click='handleUpdate(scope.row)'
                        >修改
                        </el-button>
                        <el-button
                            icon='el-icon-share'
                            size='mini'
                            type='text'
                            @click='handleShowRole(scope.row)'
                        >查看
                        </el-button>
                        <el-button
                            icon='el-icon-delete'
                            size='mini'
                            type='text'
                            @click='handleDelete(scope.row)'
                        >删除
                        </el-button>
                    </template>
                </el-table-column>
            </el-table>
            
            <div class='pagination'>
                <el-pagination
                    :current-page='queryParams.pageNum'
                    :page-size='queryParams.pageSize'
                    :total='queryParams.total'
                    background
                    layout='prev, pager, next'
                    @current-change='handlePagination'>
                </el-pagination>
            </div>
            
            <!-- 添加或修改参数配置对话框 -->
            <el-dialog :title='title' :visible.sync='open' append-to-body width='500px'>
                <el-form ref='form' :model='form' :rules='rules' label-width='80px'>
                    <el-form-item label='接口名' prop='name'>
                        <el-input v-model='form.name' placeholder='请输入接口名称' />
                    </el-form-item>
                    <el-form-item label='接口地址' prop='url'>
                        <el-input v-model='form.url' placeholder='请输入接口地址' />
                    </el-form-item>
                </el-form>
                <div slot='footer' class='dialog-footer'>
                    <el-button type='primary' @click='submitForm'>确 定</el-button>
                    <el-button @click='cancel'>取 消</el-button>
                </div>
            </el-dialog>
            
            <el-dialog title='授权角色列表' :visible.sync='roleOpen' append-to-body width='500px'>
                <div>
                    <p v-for='(item, index) in authorizationRoleList' :key='index' style='margin-bottom: 10px'>
                        <el-tag size='mini'>{{item.roleName}}</el-tag>
                    </p>
                </div>
            </el-dialog>
            
            <!--导入连接-->
            <el-dialog
                :visible='openImportDialog'
                :visible.sync='openImportDialog'
                title='导入后端Api'
                width='30%'>
                <div class='tree'>
                    <el-row :gutter='20'>
                        <el-col :span='18'>
                            <el-input size='mini' placeholder='请输入过滤条件' v-model='treeFilterText'/>
                        </el-col>
                        <el-col :span='6'>
                            <el-button @click='handleChoseAll' size='mini' type="primary">全选</el-button>
                        </el-col>
                    </el-row>
                    <el-tree
                        ref='tree'
                        :filter-node-method='handleFilterNode'
                        :render-content='handleRenderContent'
                        :data='apiInfoTreeOptions'
                        :default-checked-keys='defaultCheckUrlList'
                        :default-expand-all='false'
                        :props='defaultProps'
                        check-on-click-node
                        highlight-current
                        node-key='value'
                        show-checkbox
                        @check='handleNodeClick'
                        @node-click='handleNodeClick'>
                    </el-tree>
                </div>
                
                <template slot='footer'>
                    <el-button plain @click='openImportDialog = !openImportDialog'>取消</el-button>
                    <el-button plain type='primary' @click='handleImportSubmit'>提交</el-button>
                </template>
            </el-dialog>
        </div>
    </section>
</template>

<script>

import { message } from '@/utils/message';
import { selectRoleList } from '@/components/api/role';
import {
    deletePermissionByIdList,
    insertPermission,
    queryRoleListByPermission,
    selectPermissionList,
    updatePermission
} from '@/components/api/permission';
import { getSwaggerApiInfo, getSwaggerResources } from '@/components/api/doc';
import { EnumBackEndApiPrefix } from '@/constant/enums';

export default {
    name: 'Dict',
    data() {
        return {
            defaultProps: {
                children: 'children',
                label: 'label',
                value: 'value',
                url: 'url'
            },
            // 遮罩层
            loading: true,
            // 选中数组
            ids: [],
            // 非单个禁用
            single: true,
            // 非多个禁用
            multiple: true,
            batchDeleteStatus: false,
            // 显示搜索条件
            showSearch: true,
            permissionList: [],
            // 弹出层标题
            title: '',
            // 是否显示弹出层
            open: false,
            roleOpen: false,
            // 查询参数
            queryParams: {
                total: 0,
                pageNum: 1,
                pageSize: 15,
                name: undefined,
                id: undefined,
                url: undefined
            },
            // 表单参数
            form: {},
            // 表单校验
            rules: {
                name: [
                    { required: true, message: '权限名称不能为空', trigger: 'blur' }
                ],
                url: [
                    { required: true, message: '请求地址', trigger: 'blur' }
                ]
            },
            updateStatus: false,
            currentPermissionInfo: {},
            apiInfoTreeOptions: [],
            openImportDialog: false,
            checkedUrlList: [],
            defaultCheckUrlList: [],
            apiInfoList: [],
            treeFilterText: undefined,
            authorizationRoleList: []
        };
    },
    watch: {
        treeFilterText(val) {
            this.$refs.tree.filter(val)
        }
    },
    created() {
        this.getList();
    },
    methods: {
        handleChoseAll() {
            this.apiInfoTreeOptions.forEach((api, index) => {
                if (api.children) {
                    api.children.forEach((child, childIndex) => {
                        if (!child.disabled) {
                            let arr = this.$refs.tree.getCheckedKeys()
                            arr.push(child.url)
                            this.$refs.tree.setCheckedKeys(arr)
                        }
                    })
                }
            })
        },
        handleFilterNode(value, data) {
            if (!value) return true;
            return data.url.indexOf(value) !== -1;
        },
        handleRenderContent(h, { node, data, store }) {
            if (!data.children) {
                return (<el-tooltip className='item' effect='dark' placement='right'>
                    <template slot='content'>{data.url}</template>
                    <span>{node.label}</span></el-tooltip>);
            }
            return (<span>{node.label}</span>);
        },
        handlePagination(pageNum) {
            this.queryParams.pageNum = pageNum;
            this.getList();
        },
        handleImportSubmit() {
            let checkApiArr = []
            this.$refs.tree.getCheckedKeys().forEach(api => {
                if (api !== undefined) {
                    checkApiArr.push(api)
                }
            })
            this.checkedUrlList = []
            this.checkedUrlList = checkApiArr
            if (!this.checkedUrlList || this.checkedUrlList.length === 0) {
                message.warning('请选择后端接口');
                return;
            }
            let checkedUrlListTemp = this.checkedUrlList;
            let apiInfoListTemp = this.apiInfoList;
            let dom = this;
            this.$modal.confirm(`你确定要添加 ${this.checkedUrlList.length} 个接口么?`).then(function() {
                checkedUrlListTemp.forEach((api, index) => {
                    apiInfoListTemp.forEach(info => {
                        if (api === info.url) {
                            let name = '';
                            if (info.tag) {
                                name = info.tag;
                            }
                            if (info.label) {
                                if (name.length > 0) {
                                    name = name + '-' + info.label;
                                } else {
                                    name = info.label;
                                }
                            }
                            if (name.length === 0) {
                                name = api;
                            }
                            insertPermission(api, name);
                            if (index === checkedUrlListTemp.length - 1) {
                                message.success('批量添加成功');
                                dom.getList();
                                dom.handleImport();
                                dom.openImportDialog = false;
                            }
                        }
                    });
                });
            });
        },
        handleNodeClick(data) {
            // 如果执行的是父节点
            if (data.children) {
                data.children.forEach(son => {
                    if (!son.disabled) {
                        const uri = son.url;
                        if (!this.checkedUrlList.includes(uri)) {
                            this.checkedUrlList.push(uri);
                        }
                    }
                });
            } else {
                const uri = data.value;
                if (!this.checkedUrlList.includes(uri)) {
                    this.checkedUrlList.push(uri);
                }
            }
        },
        resetForm(refName) {
            if (this.$refs[refName]) {
                this.$refs[refName].resetFields();
            }
        },
        /** 查询字典类型列表 */
        getList() {
            this.loading = true;
            const param = this.queryParams;
            
            selectPermissionList(param.id, param.url, param.name, param.pageNum, param.pageSize).then(response => {
                    if (response.code === 200) {
                        this.permissionList = response.data.result;
                        this.queryParams.total = response.data.total;
                        this.loading = false;
                        this.queryParams.pageNum = response.data.pageNum;
                    } else {
                        this.loading = false;
                    }
                }
            );
            
            selectRoleList(null, null, null).then(result => {
                if (result.code === 200) {
                    this.roleList = result.data.result;
                } else {
                    message.error(result.message);
                }
            });
        },
        // 取消按钮
        cancel() {
            this.open = false;
            this.reset();
        },
        // 表单重置
        reset() {
            this.form = {
                name: undefined,
                url: undefined,
                id: undefined
            };
            this.resetForm('form');
        },
        /** 搜索按钮操作 */
        handleQuery() {
            this.queryParams.pageNum = 1;
            this.getList();
        },
        /** 重置按钮操作 */
        resetQuery() {
            this.resetForm('queryForm');
            this.queryParams = {};
            this.handleQuery();
        },
        /** 新增按钮操作 */
        handleAdd() {
            this.reset();
            this.open = true;
            this.title = '添加权限';
            this.updateStatus = false;
        },
        handleBatchDelete() {
            let idList = this.ids
            const obj = this
            this.$modal.confirm(`是否删除 ${idList.length} 条数据?`).then(function() {
                return deletePermissionByIdList(idList)
            }).then(result => {
                if (result.code === 200) {
                    message.success("删除成功")
                    obj.getList()
                }
            })
        },
        // 多选框选中数据
        handleSelectionChange(selection) {
            this.ids = selection.map(item => item.id);
            this.batchDeleteStatus = this.ids.length > 0
        },
        handleShowRole(row) {
            queryRoleListByPermission([row]).then(result => {
                if (result.code === 200) {
                    this.roleOpen = true
                    this.authorizationRoleList = result.data.roleList
                }
            })
        },
        /** 修改按钮操作 */
        handleUpdate(row) {
            this.reset();
            this.form = row;
            this.open = true;
            this.title = '修改接口信息';
            this.updateStatus = true;
            this.currentPermissionInfo = row;
        },
        /** 提交按钮 */
        submitForm: function() {
            this.$refs['form'].validate(valid => {
                if (valid) {
                    if (this.updateStatus) {
                        if (!this.form.id) {
                            this.$modal.msgError('id不能为空');
                            return;
                        }
                        if (this.form.url === this.currentPermissionInfo.url) {
                            this.form.url = undefined;
                        }
                        updatePermission(this.form.id, this.form.url, this.form.name).then(result => {
                            if (result.code === 200) {
                                message.success('修改成功');
                                this.getList();
                                this.open = false;
                            }
                        });
                    } else {
                        insertPermission(this.form.url, this.form.name).then(result => {
                            if (result.code === 200) {
                                message.success('添加成功');
                                this.getList();
                                this.open = false;
                            }
                        });
                    }
                }
            });
        },
        /** 删除按钮操作 */
        handleDelete(row) {
            this.$modal.confirm('是否确认删除接口"' + row.name + '"的数据项？').then(function() {
                return deletePermissionByIdList([row.id]);
            }).then((result) => {
                if (result.code === 200) {
                    this.getList();
                    this.$modal.msgSuccess('删除成功');
                }
            }).catch(() => {
            });
        },
        // 获取模块信息
        async getModuleInfo() {
            let moduleList = [];
            for (const apiPrefix of EnumBackEndApiPrefix) {
                const result = await getSwaggerResources(apiPrefix);
                if (result.data) {
                    for (let i = 0; i < result.data.length; i++) {
                        result.data[i].url = `/${apiPrefix}${result.data[i].url}`;
                        moduleList.push(result.data[i]);
                    }
                }
            }
            return moduleList;
        },
        // 通过模块信息，获取api接口信息
        async getApiInfo(moduleList) {
            let apiInfoList = [];
            for (let i = 0; i < moduleList.length; i++) {
                const apiInfo = await getSwaggerApiInfo(moduleList[i].url);
                let pathList = Array.of(apiInfo.data.paths);
                let moduleApiInfoMap = new Map();
                for (let j = 0; j < pathList.length; j++) {
                    // 获取api请求uri
                    for (const apiPath in pathList[j]) {
                        // 获取该api的请求方法
                        for (const method in pathList[j][apiPath]) {
                            // 获取api的数据
                            let tag = pathList[j][apiPath][method]['tags'][0] ? pathList[j][apiPath][method]['tags'][0] : apiPath;
                            let description = pathList[j][apiPath][method]['summary'] ? pathList[j][apiPath][method]['summary'] : apiPath;
                            let upperMethod = method.toUpperCase();
                            let info = {
                                uri: apiPath,
                                method: upperMethod,
                                tag: tag,
                                description: description
                            };
                            if (!moduleApiInfoMap.get(pathList[j][apiPath][method]['tags'][0])) {
                                moduleApiInfoMap.set(pathList[j][apiPath][method]['tags'][0], []);
                            }
                            moduleApiInfoMap.get(pathList[j][apiPath][method]['tags'][0]).push(info);
                        }
                    }
                }
                apiInfoList.push(moduleApiInfoMap);
            }
            return apiInfoList;
        },
        async handlePackApi() {
            this.apiInfoTreeOptions = [];
            this.apiInfoList = [];
            this.openImportDialog = true;
            let moduleList = await this.getModuleInfo();
            let apiInfoList = await this.getApiInfo(moduleList);
            for (let i = 0; i < apiInfoList.length; i++) {
                for (const [tag, paths] of apiInfoList[i]) {
                    let parentOption = {
                        label: tag,
                        url: tag,
                        disabled: false,
                        children: []
                    };
                    for (let j = 0; j < paths.length; j++) {
                        let sonOption = {
                            label: paths[j]['description'],
                            tag: paths[j]['tag'],
                            disabled: false,
                            value: `${paths[j]['method']}:${paths[j]['uri']}`,
                            url: `${paths[j]['method']}:${paths[j]['uri']}`
                        };
                        this.apiInfoList.push({
                            url: `${paths[j]['method']}:${paths[j]['uri']}`,
                            tag: paths[j]['tag'],
                            label: paths[j]['description'],
                            value: `${paths[j]['method']}:${paths[j]['uri']}`,
                            disabled: false
                        });
                        parentOption.children.push(sonOption);
                    }
                    this.apiInfoTreeOptions.push(parentOption);
                }
            }
            
            return this.apiInfoTreeOptions;
        },
        /** 导入后端接口 */
        async handleImport() {
            this.checkedUrlList = [];
            this.defaultCheckUrlList = [];
            let apiTreeOptions = await this.handlePackApi();
            let permissionResult = await selectPermissionList(null, null, null, null, 10000);
            let queryPermissionList = permissionResult.data.result;
            // 已经添加的api添加禁用标识
            this.apiInfoTreeOptions.forEach((parent, index) => {
                if (!parent.children) {
                    return;
                }
                let children = parent.children;
                this.apiInfoTreeOptions[index].children = [];
                children.forEach((son, indexSon) => {
                    this.apiInfoTreeOptions[index].children.push(son);
                    queryPermissionList.forEach(permission => {
                        if (son.url === permission.url) {
                            son.disabled = true;
                            this.defaultCheckUrlList.push(son.value);
                            this.apiInfoTreeOptions[index].children[indexSon].disabled = true;
                            
                        }
                    });
                });
            });
        }
        
        
    }
};
</script>
<style>
.el-tree {
    min-width: 100%;
    display: inline-block;
}

.tree {
    overflow: auto;
    max-height: 60vh;
}
</style>